import { useEffect } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase/config";
import { useRoomsStore } from "../store/useRoomsStore";

// Handles all deck + hand listeners for a group of players
export const useDeckAndHandListeners = (roomId, playerIds = []) => {
  const { setHand, setDeck, clearPlayerData } = useRoomsStore.getState();

  useEffect(() => {
    if (!roomId || playerIds.length === 0) return;

    const unsubscribers = [];

    playerIds.forEach((playerId) => {
      const handRef = doc(db, "rooms", roomId, "hands", playerId);
      const deckRef = doc(db, "rooms", roomId, "decks", playerId);

      const unsubHand = onSnapshot(handRef, (snap) => {
        if (snap.exists()) {
          setHand(playerId, snap.data()?.cards || []);
        }
      });

      const unsubDeck = onSnapshot(deckRef, (snap) => {
        if (snap.exists()) {
          setDeck(playerId, snap.data()?.cards || []);
        }
      });

      unsubscribers.push(unsubHand, unsubDeck);
    });

    return () => {
      unsubscribers.forEach((unsub) => unsub());
      clearPlayerData(); // reset store state
    };
  }, [roomId, playerIds.join(",")]); // playerIds.join forces re-run if list changes
};
